import { render, staticRenderFns } from "./order-import.vue?vue&type=template&id=53b96801&scoped=true&"
import script from "./order-import.vue?vue&type=script&lang=js&"
export * from "./order-import.vue?vue&type=script&lang=js&"
import style0 from "./order-import.vue?vue&type=style&index=0&id=53b96801&scoped=true&lang=scss&"
import style1 from "./order-import.vue?vue&type=style&index=1&id=53b96801&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b96801",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53b96801')) {
      api.createRecord('53b96801', component.options)
    } else {
      api.reload('53b96801', component.options)
    }
    module.hot.accept("./order-import.vue?vue&type=template&id=53b96801&scoped=true&", function () {
      api.rerender('53b96801', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nb/supplyChain/delivery/order-import.vue"
export default component.exports